import React from 'react';

interface EditorToolbarProps {
  children?: React.ReactNode;
}

export const EditorToolbar: React.FC<EditorToolbarProps> = ({
  children
}) => {
  return (
    <div className="editor-toolbar">
      <div className="editor-toolbar-label">Code Editor</div>
      {children}
    </div>
  );
};